interface IStorage {
  getItem(key: string, parse: boolean): string | null
  getItem(key: string, parse: boolean): null | Object
  setItem(key: string, value: string): void
  setItem(key: string, value: Object): void
  removeItem(key: string): void
  clear(): void
}

export default abstract class Storage<T extends string> {
  private readonly storage: IStorage

  public constructor(getStorage = (): IStorage => window.localStorage) {
    this.storage = getStorage()
  }

  protected get(key: T, parse: boolean = false): string | null {
    const result = this.storage.getItem(key, parse)
    if (parse) {
      return JSON.parse(result!!)
    } else {
      return result
    }
  }

  protected set(key: T, value: string): void {
    this.storage.setItem(key, value)
  }

  protected clearItem(key: T): void {
    this.storage.removeItem(key)
  }

  protected clearItems(keys: T[]): void {
    keys.forEach(key => this.clearItem(key))
  }

  protected clearStorage(): void {
    this.storage.clear()
  }

  protected setItemObject(key: T, value: Object): void {
    this.storage.setItem(key, JSON.stringify(value))
  }

  protected getItemObject(key: T): null | Object {
    const result = this.storage.getItem(key, true)
    return JSON.parse(result!!)
  }
}
